import React from 'react';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';

type ParentProps = {
  isLoading: boolean;
  color?: string;
  size?: string | number;
  className?: string;
};

const useStyles = makeStyles({
  loader: {
    border: (props: ParentProps) => `5px solid #e0e0e0`,
    borderTop: (props: ParentProps) => `5px solid ${props.color || '#ff6600'}`,
    borderRadius: '50%',
    animation: '$spin 1.5s linear infinite',
    width: (props: ParentProps) => {
      const spinnerSize = (props.size && +props.size) || 50;
      return spinnerSize;
    },
    height: (props: ParentProps) => {
      const spinnerSize = (props.size && +props.size) || 50;
      return spinnerSize;
    },
  },
  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },
});

const LoadingIndicator: React.FC<ParentProps> = (props): JSX.Element | null => {
  const { isLoading, className } = props;
  const classes = useStyles(props);

  if (!isLoading) {
    return null;
  }

  return <div className={classNames(classes.loader, className)} />;
};

export default LoadingIndicator;
